import { Component, OnInit, Input } from '@angular/core';
import { Venta } from '../../../models/venta';
import { VentaService } from '../../../services/venta.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { SessionService } from '../../../services/session.service';
import { SerieService } from '../../../services/serie.service';
import { SerieDetalleModalComponent } from '../serie-detalle-modal/serie-detalle-modal.component';
import { BsModalService } from 'ngx-bootstrap';

@Component({
	selector: 'venta-modal',
	templateUrl: './venta-modal.component.html',
    styleUrls: ['./venta-modal.component.css'],
    providers: [VentaService, SerieService]
})
export class VentaModalComponent implements OnInit {
    @Input() venta_id: String;
    public numero_decimales: String;
    public venta: Venta;
    public loading = false;
    public Mod_Inventario: string;
    public format_decimal: String;
    public Mod_Cartera: string;
    public bsModalRef2: BsModalRef;
    constructor(
        private ventaService: VentaService,
        public bsModalRef: BsModalRef,
        public ss: SessionService,
        private serieService: SerieService,
        private modalService: BsModalService,
        
    ){
        this.venta = new Venta();
        this.Mod_Inventario = this.ss.getData("mod_inventario");
        this.Mod_Cartera = this.ss.getData("mod_cartera");
        this.numero_decimales = this.ss.getData("numero_decimales");
        this.format_decimal = "0,0.00";
    }

    ngOnInit(){
        let digitos = "";
		for(let i = 0; i < parseInt(this.numero_decimales.toString()); i++) digitos += "0";
        this.format_decimal = "0,0." + digitos
        
        this.getVentaById();
    }

    getVentaById(){
        this.loading = true;
        let qs = '?embed=tipocomprobante,cliente,detalle?embed=producto,bodega,detalle?embed=series?embed=serie';
        this.ventaService.getById(this.venta_id, qs).subscribe(
            res => {
                this.loading = false;
                this.venta = res.data;

                this.venta.detalle.forEach(d=>{
                    d.series.forEach( s => {
                        this.serieService.getById(s.serie_id).subscribe(
                            res => {
                               s.serie = res.data;
                                this.loading = false;
                            },
                            err => {
                                this.loading = false;
                            }
                        );
                    })    
                   
                });
            },
            err => {
                this.loading = false;
            }
        );
    }

    getCodigoSerie(codigo = ''){
        return codigo + ', ';
    }

    getDetalleVenta(ventaDetalle){
        return ventaDetalle.producto.nombre + (ventaDetalle.detalle.length>0?" - " + ventaDetalle.detalle:"");
    }

    get formatDecimal(){
        return this.format_decimal;
    }

    openModalSerie(series: Array<any>) {
		const initialState = { series: series,numero_decimales: this.numero_decimales };
		this.bsModalRef2 = this.modalService.show(SerieDetalleModalComponent, Object.assign({backdrop: 'static',initialState }));

		
	}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/venta-modal/venta-modal.component.ts